import styled, { css } from 'styled-components';

import {
    Button,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

export const StyledCTAComponent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        flex-direction: column;
    `)}
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        flex-direction: column-reverse;
    `)}
`;

export const StyledButton = styled(Button)`
    margin-left: ${spaceMixin('sm')};

    /* 769 */
    ${mediaMixin('lg_eq', css`
        margin-left: 0;
        margin-bottom: ${spaceMixin('xs')};
    `)}
`;

/* only show at the lg breakpoint */
export const StyledVONContainer = styled.div`
    display: none;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        display: block;
    `)}
`;
